export const editorItemKey = (item) =>
  `${String(item.albumSource).toUpperCase()}:${String(item.sourceId)}`;
export const uniqueEditorItems = (items = []) => {
  const used = new Set();
  return items.filter((item) => {
    const key = editorItemKey(item);
    if (!item.sourceId || !item.albumSource || used.has(key)) return false;
    used.add(key);
    return true;
  });
};
export const orderedEditorItems = (items = []) =>
  uniqueEditorItems([...items].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)));
export function editorPayload(draft, mode, initialExternalLink) {
  const link = draft.externalLinkUrl.trim();
  return {
    title: draft.title.trim(),
    description: draft.description.trim(),
    imageUrl: draft.imageUrl,
    ...(link
      ? { externalLinkUrl: link }
      : mode === 'edit' && initialExternalLink
        ? { externalLinkUrl: '' }
        : {}),
    ...(mode === 'create' ? { type: draft.type } : {}),
    [draft.type === 'TRACK' ? 'tracks' : 'albums']: draft.items.map((item, position) => ({
      sourceId: item.sourceId,
      albumSource: String(item.albumSource).toUpperCase(),
      position,
    })),
  };
}
export function editorError(draft) {
  if (!draft.title.trim() || draft.title.length > 60) return 'title';
  if (draft.description.length > 5000) return 'description';
  if (draft.externalLinkUrl.trim()) {
    try {
      const url = new URL(draft.externalLinkUrl.trim());
      if (
        !['http:', 'https:'].includes(url.protocol) ||
        !url.hostname ||
        draft.externalLinkUrl.length > 2048
      )
        return 'externalLinkUrl';
    } catch {
      return 'externalLinkUrl';
    }
  }
  if (!draft.items.length) return 'items';
  return null;
}
export function cancelEditorPath(mode, id, search) {
  const p = new URLSearchParams(search),
    from = p.get('from'),
    query = new URLSearchParams();
  if (p.get('returnPage')) query.set('page', p.get('returnPage'));
  if (from === 'mypage') return '/mypage/lists' + (query.toString() ? '?' + query : '');
  if (from === 'list') {
    if (p.get('returnSort')) query.set('sort', p.get('returnSort'));
    return '/lists' + (query.toString() ? '?' + query : '');
  }
  return mode === 'edit' ? `/lists/${encodeURIComponent(id)}` : '/lists';
}
export function movedEditorItems(items, active, over) {
  if (!over || active === over) return items;
  const a = items.findIndex((x) => editorItemKey(x) === active),
    b = items.findIndex((x) => editorItemKey(x) === over);
  if (a < 0 || b < 0) return items;
  const result = [...items],
    [item] = result.splice(a, 1);
  result.splice(b, 0, item);
  return result;
}
export const editorSnapshot = (draft) =>
  JSON.stringify({ ...draft, items: draft.items.map(editorItemKey) });
